import React from 'react';
import ReactTable from '../components/ReactTable';
import { usePositionHistoryCols } from '../hooks/EmployeeCols';
import { Box, CircularProgress } from '@material-ui/core';

export default function PositionHistory(props) {
    const positionHistoryCols = usePositionHistoryCols();
    
    if (props.isLoading && !props.data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }
    
    if (!props.data) return null;
    return <ReactTable cols={positionHistoryCols} data={props.data} isLoading={props.isLoading} />;
}
